import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';
import { UserOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Form as FormikForm, FormItem, Input, Radio } from 'formik-antd';
import { titleOptions, getIsUploading, getUrlFromEvent } from 'utils/form';
import { Upload, Fieldset } from 'components/form';
import { DB_PREFIX } from './constants';

const header = `
Welcome to MyShifts please complete the following registration form.
You can save your progress and return at anytime to complete.
Once you are fully registered you will receive an email confirmation from us and you can log-in to search for workers and buy tokens.
This information is required to enable MyShifts to identify/verify the lead person in your organisation.
The information provided will not be shared with potential workers.
`;

const Form = ({ isSubmitting, values, setFieldValue, uploadTo, children }) => {
  const [uploading, setUploading] = useState(false);

  return (
    <FormikForm layout="vertical">
      <FormItem label="Company Logo" name={`${DB_PREFIX}.photoURL`}>
        <Upload
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          uploadTo={uploadTo}
          multiple={false}
          disabled={uploading || isSubmitting}
          onChange={(e) => {
            setUploading(getIsUploading(e));
            setFieldValue(`${DB_PREFIX}.photoURL`, getUrlFromEvent(e));
          }}
        >
          {values[DB_PREFIX].photoURL ? (
            <img src={values[DB_PREFIX].photoURL} alt="avatar" />
          ) : (
            <div>
              {uploading ? <LoadingOutlined /> : <PlusOutlined />}
              <div className="ant-upload-text">
                {uploading ? 'Uploading' : 'Upload'}
              </div>
            </div>
          )}
        </Upload>
      </FormItem>

      {header !== '' && (
        <>
          <Alert description={header} type="info" />
        </>
      )}

      <Fieldset>
        <FormItem label="First Name" name={`${DB_PREFIX}.firstName`}>
          <Input
            name={`${DB_PREFIX}.firstName`}
            placeholder="Name"
            prefix={<UserOutlined />}
          />
        </FormItem>
        <FormItem label="Last Name" name={`${DB_PREFIX}.lastName`}>
          <Input
            name={`${DB_PREFIX}.lastName`}
            placeholder="Last name"
            prefix={<UserOutlined />}
          />
        </FormItem>
      </Fieldset>

      <Fieldset>
        <FormItem label="Preferred title" name={`${DB_PREFIX}.title`}>
          <Radio.Group name={`${DB_PREFIX}.title`}>
            {titleOptions.map(({ value, label }) => (
              <Radio.Button key={value} value={value}>
                {label}
              </Radio.Button>
            ))}
          </Radio.Group>
        </FormItem>
        <FormItem label="Mobile phone number" name={`${DB_PREFIX}.mobilePhone`}>
          <Input name={`${DB_PREFIX}.mobilePhone`} />
        </FormItem>
      </Fieldset>

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
};

Form.defaultProps = {
  children: null,
};

export default Form;
